var mobileCheck = function () {
  var userAgent = false;
  var mobileWidth = false;
  if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
     ) {
    userAgent = true;
  }
  else {
    userAgent =  false;
  }
  if(window.innerWidth <= 800 && window.innerHeight <= 600) {
    mobileWidth = true;
  } else {
    mobileWidth =  false;
  }

  //             alert( "UA: "+userAgent +" MW: "+ mobileWidth);
  return (userAgent || mobileWidth);
};

function updateFeatureImage(e){
        var $this = e;
        var $featuredImage =  $this.closest('.product-item').find('.product_image').find('img'); 
        var color = $this.closest('.color').attr('data-value'); 
        var meta=  $this.closest('.product-item').find('meta[data-alt="'+color+'"]');
        var src = meta.attr('data-src');
       // $featuredImage.attr("src", src);
      }

if(!mobileCheck()){
  var counter = 0;
  var checkDiv_20210709 = setInterval(function(){
    if(typeof jQuery=='function' && jQuery('.product-top .owl-item').length){
      console.log('check');
      clearInterval(checkDiv_20210709);
      
      // zoom
      var script = document.createElement("script");
      var counter = 0;
      script.type = "text/javascript";
      script.charset = "utf-8";
      script.src = "https://cdn.shopify.com/s/files/1/2665/2414/t/348/assets/zoomslider.js";

      script.onload = function() {
        jQuery(".product-single__photo--has-thumbnails:not(.hide) .feature-row__image.product-featured-img").elevateZoom({zoomType: "inner"});
        jQuery('.grid__item #thumbnail-slider ul li.product-single__thumbnails-item,.arrow-right,.arrow-left').click(function(){
          console.log('clciked arr.../');
          jQuery('.zoomContainer').remove();
          jQuery(".product-single__photo--has-thumbnails:not(.hide) .feature-row__image.product-featured-img").elevateZoom({zoomType: "inner"});
        });
      }
      document.body.appendChild(script);
      
    }else{
      counter++;
    }
    if(counter > 50){
      clearInterval(checkDiv_20210709);
    }
  },200);
}


var ccounter = 0;
var checkDiv_20210820 = setInterval(function(){
    if(typeof jQuery=='function' && jQuery('.product-top .owl-item').length && jQuery('.color').length && jQuery(".product-mobile-thumbs-slider-top").length && jQuery(".product-mobile-thumbs-slider-bottom").length){	
      	clearInterval(checkDiv_20210820);
		setTimeout(function(){
          
          var colorSwatch = $('meta[data-id="product-color"]').attr('data-color');
          var colorSwatchBottom = $('meta[data-id="product-color-bottom"]').attr('data-color');
          var $thisTop =  $('.color[data-value="'+colorSwatch+'"]').find('input');
          var $thisBottom =  $('.color[data-value="'+colorSwatchBottom+'"]').find('input');

          updateFeatureImage($thisTop);
          updateFeatureImage($thisBottom);
          $(".eci-product_image--container").css('visibility','visible');
        },500)

    }else{
      ccounter++;
    }
    if(ccounter > 50){
      clearInterval(checkDiv_20210820);
      $(".eci-product_image--container").css('visibility','visible');
    }
},300);